var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeviationDetection(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25 25",
    style: {
      enableBackground: "new 0 0 25 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t\t.DevaitionDetection-st0 {\r\n\t\t\tfill: currentColor;\r\n\t\t}\r\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "DevaitionDetection-st0",
    d: "M10.1,0.1v2.4H4.8c-1.2,0-2.4,1.1-2.4,2.4v15.8c0,1.2,1.1,2,2.4,2h5.4v2.4h2.4V0.1H10.1z M10.1,19.2H4.8 l5.4-6.7V19.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DevaitionDetection-st0",
    d: "M20.2,2.4h-5.4v2.4h5.4v14.5l-5.4-6.7v10.1h5.4c1.2,0,2.4-0.8,2.4-2V4.8C22.6,3.5,21.5,2.4,20.2,2.4L20.2,2.4z "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviationDetection);
export default __webpack_public_path__ + "static/media/DeviationDetection.17f13d938123ad997ac0ecd584afaa65.svg";
export { ForwardRef as ReactComponent };